// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll(".site-nav__item").forEach((item) => {
//     let timer;

//     item.addEventListener("mouseenter", () => {
//       clearTimeout(timer);
//       item.classList.add("is-open");
//     });

//     item.addEventListener("mouseleave", () => {
//       timer = setTimeout(() => {
//         item.classList.remove("is-open");
//       }, 250);
//     });

//     // Handle sub-sub-nav if present
//     item.querySelectorAll(".sub-nav__item").forEach((subItem) => {
//       let subTimer;
//       subItem.addEventListener("mouseenter", () => {
//         clearTimeout(subTimer);
//         subItem.classList.add("is-open");
//       });
//       subItem.addEventListener("mouseleave", () => {
//         subTimer = setTimeout(() => {
//           subItem.classList.remove("is-open");
//         }, 250);
//       });
//     });
//   });
// });

function initMenu() {
  document.addEventListener("DOMContentLoaded", () => {
    const menuParents = document.querySelectorAll(
      ".site-nav__item.has-children, .sub-nav__item.has-children",
    );

    const expandSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_1247_1779" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_1247_1779)">
    <path d="M12.9462 12L8.34619 7.4L9.39994 6.34625L15.0537 12L9.39994 17.6538L8.34619 16.6L12.9462 12Z" fill="#1C1B1F"/>
  </g>
</svg>
`;

    // SVG for the back button
    const backSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_1096_1177" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect x="24" y="24" width="24" height="24" transform="rotate(-180 24 24)" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_1096_1177)">
    <path d="M11.0538 12L15.6538 16.6L14.6001 17.6537L8.94631 12L14.6001 6.34625L15.6538 7.4L11.0538 12Z" fill="#1C1B1F"/>
  </g>
</svg>
`;

    menuParents.forEach((parent) => {
      // Create the toggle button
      const toggle = document.createElement("button");
      toggle.classList.add("menu-toggle");
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Toggle submenu");

      // Inject the SVG inside the button
      toggle.innerHTML = expandSVG;

      // Insert toggle button after the link
      const link = parent.querySelector("a");
      if (link && link.nextSibling) {
        link.parentNode.insertBefore(toggle, link.nextSibling);
      } else {
        parent.appendChild(toggle);
      }

      // Add click handler for opening submenu
      toggle.addEventListener("click", () => {
        const expanded = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!expanded));
        parent.classList.toggle("open", !expanded);
      });

      // Add back button (same as before)
      const submenu = parent.querySelector(
        ":scope > .sub-nav, :scope > .sub-sub-nav__wrapper",
      );

      if (submenu) {
        const backBtn = document.createElement("button");
        backBtn.classList.add("menu-back");
        backBtn.setAttribute("aria-label", "Go back");
        // Insert SVG + parent text
        backBtn.innerHTML = `${backSVG} <span>${
          link ? link.textContent.trim() : "Back"
        }</span>`;
        submenu.insertBefore(backBtn, submenu.firstChild);

        backBtn.addEventListener("click", () => {
          parent.classList.remove("open");
          const toggleBtn = parent.querySelector(".menu-toggle");
          if (toggleBtn) toggleBtn.setAttribute("aria-expanded", "false");
        });
      }
    });

    const menu = document.querySelector(".header__menu");
    const toggleButton = document.querySelector(".js-open-menu");
    const header = document.querySelector(
      ".shopify-section-group-header-group",
    );

    const body = document.body;

    if (menu && toggleButton && header) {
      toggleButton.addEventListener("click", () => {
        const isOpen = menu.classList.contains("menu-open");
        const headerHeight = header.offsetHeight;
        const viewportHeight = window.innerHeight;

        if (!isOpen) {
          // Open menu
          menu.style.setProperty(
            "--menu-max-height",
            `${viewportHeight - headerHeight}px`,
          );
          menu.style.setProperty("--header-height", `${headerHeight}px`);
          menu.classList.add("menu-open");
          toggleButton.classList.add("menu-open");
          body.classList.add("menu-open");

          // Prevent body scroll
          const scrollY = window.scrollY;
          body.style.position = "fixed";
          body.style.width = "100%";
          // body.style.top = `-${scrollY}px`;
          // body.dataset.scrollY = scrollY; // save scroll position
        } else {
          // Close menu
          menu.classList.remove("menu-open");
          toggleButton.classList.remove("menu-open");
          body.classList.remove("menu-open");

          // ✅ Close all open submenus
          document
            .querySelectorAll(".has-children.open")
            .forEach((openItem) => {
              openItem.classList.remove("open");
              const toggleBtn = openItem.querySelector(".menu-toggle");
              if (toggleBtn) toggleBtn.setAttribute("aria-expanded", "false");
            });

          // Restore body scroll
          const scrollY = body.dataset.scrollY
            ? parseInt(body.dataset.scrollY)
            : 0;
          body.style.position = "";
          body.style.top = "";
          window.scrollTo(0, scrollY);
          delete body.dataset.scrollY;
        }
      });
    }
  });
}

initMenu();

export { initMenu };
